module.exports = require("./bn.d.ts");